import { gql } from '@apollo/client';

export const SEARCH_LOCATIONS = gql`
  query SearchLocations($query: String!) {
    searchLocations(query: $query)
  }
`;
